import React from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import {
  Box,
} from "@material-ui/core";
import AutoMLWorkflow from "./AutoMLWorkflow";




function App({fetchAPI}) {

  return (
    <div className="App">
      <StyledEngineProvider injectFirst>
          <Box>
           <AutoMLWorkflow fetchAPI={fetchAPI} />
          </Box>
      </StyledEngineProvider>
    </div>
  );
}

export default App;
